import { render } from "./LetterOpenedIcon.vue?vue&type=template&id=33ea5346"
import script from "./LetterOpenedIcon.vue?vue&type=script&lang=js"
export * from "./LetterOpenedIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__